import Vue from 'vue'
import { URL_PROXIES } from '@/constants/urls.js'
import { PROXY_TYPES } from '@/constants/business.js'
import { PROXIES_MANAGEMENT, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const state = {
  [PROXIES_MANAGEMENT.STATE.PROXIES]: {
    [PROXY_TYPES.USER_PROXY]: null
  },
  [PROXIES_MANAGEMENT.STATE.CURRENT_PROXY]: null
}

const actions = {
  async [PROXIES_MANAGEMENT.ACTIONS.GET_PROXIES_LIST_ADMIN] ({ dispatch, commit }, model) {
    const proxyType = model.proxyType
    model = {
      url: `${Vue.getIdentityHost()}${URL_PROXIES}/${model.proxyType}?${Vue.helpers.getQueryParamsString(model.params)}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(PROXIES_MANAGEMENT.MUTATIONS.GET_PROXIES_LIST_ADMIN, {
      proxyType,
      proxies: resp.data
    })
  },
  async [PROXIES_MANAGEMENT.ACTIONS.GET_PROXY_ADMIN] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_PROXIES}/${model.proxyType}/${model.proxyId}?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(PROXIES_MANAGEMENT.MUTATIONS.GET_PROXY_ADMIN, resp.data)
  },
  async [PROXIES_MANAGEMENT.ACTIONS.CHANGE_PROXY_STATUS] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_PROXIES}/${model.proxyType}/${model.proxyId}/status`,
      model: { status: model.status }
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [PROXIES_MANAGEMENT.ACTIONS.UPDATE_PROXY] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_PROXIES}/${model.proxyType}/${model.proxyId}`,
      model: model.proxy
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [PROXIES_MANAGEMENT.ACTIONS.CLEAR_PROXIES_LIST_ADMIN] ({ commit }, proxyType) {
    commit(PROXIES_MANAGEMENT.MUTATIONS.CLEAR_PROXIES_LIST_ADMIN, proxyType)
  },
  async [PROXIES_MANAGEMENT.ACTIONS.CLEAR_PROXY_ADMIN] ({ commit }) {
    commit(PROXIES_MANAGEMENT.MUTATIONS.CLEAR_PROXY_ADMIN)
  }
}

const mutations = {
  [PROXIES_MANAGEMENT.MUTATIONS.GET_PROXIES_LIST_ADMIN] (state, model) {
    state[PROXIES_MANAGEMENT.STATE.PROXIES][model.proxyType] = model.proxies
  },
  [PROXIES_MANAGEMENT.MUTATIONS.GET_PROXY_ADMIN] (state, proxy) {
    state[PROXIES_MANAGEMENT.STATE.CURRENT_PROXY] = proxy
  },
  [PROXIES_MANAGEMENT.MUTATIONS.CLEAR_PROXIES_LIST_ADMIN] (state, proxyType) {
    state[PROXIES_MANAGEMENT.STATE.PROXIES][proxyType] = null
  },
  [PROXIES_MANAGEMENT.MUTATIONS.CLEAR_PROXY_ADMIN] (state) {
    state[PROXIES_MANAGEMENT.STATE.CURRENT_PROXY] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
